import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Text, TouchableHighlight, View } from 'react-native';

import defaultStyles from './HighlighButton.jss';

const HighlightButton = ({ onPress, title, style, testID, underlayColor }) => {
    const [isPressed, setIsPressed] = useState(false);

    return (
        <TouchableHighlight
            testId={testID}
            underlayColor={underlayColor}
            style={[
                defaultStyles.button,
                defaultStyles.secondarydefaultStyles,
                defaultStyles.textContainerDropdown,
                style.button
            ]}
            onPress={onPress}
            onPressIn={() => setIsPressed(true)}
            onPressOut={() => setIsPressed(false)}
        >
            <View style={[defaultStyles.textContainerWithoutIcon]}>
                <Text
                    numberOfLines={1}
                    ellipsizeMode="middle"
                    style={[defaultStyles.text, style.text, isPressed && style.textHighlight]}
                    adjustsFontSizeToFit
                >
                    {title}
                </Text>
            </View>
        </TouchableHighlight>
    );
};

HighlightButton.propTypes = {
    onPress: PropTypes.func,
    title: PropTypes.string,
    style: PropTypes.shape({}),
    testID: PropTypes.string,
    underlayColor: PropTypes.string
};

HighlightButton.defaultProps = {
    onPress: () => {},
    title: '',
    style: {},
    testID: undefined,
    underlayColor: '#A4A4A4'
};

export default HighlightButton;
